export enum GlobalSoftwareFaqRoutes {
  BASE = 'kb-search'
}
